import ScoutCreationPage from './ScoutCreationPage';

export default ScoutCreationPage;